(function () {

  window.updateCartProgressBar = function (itemCount, cartTotal) {
    const fill = document.getElementById('cpb-fill');
    const message = document.getElementById('cpb-message');

    const msShip = document.getElementById('milestone-shipping');
    const ms10 = document.getElementById('milestone-10');
    const ms15 = document.getElementById('milestone-15');

    if (!fill || !message) return;

    // ====== 阶梯金额（核心）======
    const FREE = 10000;
    const OFF10 = 15000;
    const OFF15 = 25000;

    // ====== 进度计算（真正线性）======
    const progress = Math.min((cartTotal / OFF15) * 100, 100);
    fill.style.width = progress + '%';

    // ====== milestone（改为金额驱动）======
    msShip?.classList.toggle('is-reached', cartTotal >= FREE);
    ms10?.classList.toggle('is-reached', cartTotal >= OFF10);
    ms15?.classList.toggle('is-reached', cartTotal >= OFF15);

    // ====== 文案 ======
    let html = '';

    if (cartTotal < FREE) {
      const remaining = ((FREE - cartTotal) / 100).toFixed(2);
      html = `🚚 Spend <strong>$${remaining}</strong> more for <strong>Free Shipping</strong>`;

    } else if (cartTotal < OFF10) {
      const remaining = ((OFF10 - cartTotal) / 100).toFixed(2);
      html = `🎁 Spend <strong>$${remaining}</strong> more for <strong>10% OFF</strong>`;

    } else if (cartTotal < OFF15) {
      const remaining = ((OFF15 - cartTotal) / 100).toFixed(2);
      html = `🎉 Spend <strong>$${remaining}</strong> more for <strong>15% OFF</strong>`;

    } else {
      html = `🔥 You unlocked <strong>15% OFF</strong> + Free Shipping!`;
    }

    // ====== 动画 ======
    message.style.opacity = '0';
    setTimeout(() => {
      message.innerHTML = html;
      message.style.opacity = '1';
    }, 200);
  };


  // ====== API 刷新 ======
  function refreshCartData() {
    fetch(window.Shopify.routes.root + 'cart.js')
      .then(res => res.json())
      .then(cart => {

        let originalTotal = 0;

        cart.items.forEach(item => {
          originalTotal += item.original_line_price;
        });

        window.updateCartProgressBar(cart.item_count, originalTotal);

      })
      .catch(console.error);
  }


  // ====== 拦截购物车请求 ======
  const originalFetch = window.fetch;
  window.fetch = function () {
    return originalFetch.apply(this, arguments).then(response => {

      const url = response.url || '';

      if (
        url.includes('/cart/add') ||
        url.includes('/cart/update') ||
        url.includes('/cart/change') ||
        url.includes('/cart/clear')
      ) {
        setTimeout(refreshCartData, 300);
      }

      return response;
    });
  };


  // ====== 初始加载 ======
  document.addEventListener('DOMContentLoaded', refreshCartData);

})();